import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Input, InputNumber, Button, Card, Typography, message, Space } from 'antd';
import styled from 'styled-components';
import PersistentDrawerLeft from "../../../components/reusable/admin/Main";
import { restApi } from "../../../constants/api";

const { Title } = Typography;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f9f9f9;
`;

const StyledCard = styled(Card)`
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 16px;
`;

const StyledButton = styled(Button)`
  background-color: #1677ff;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  font-weight: 500;
  font-size: 16px;

  &:hover {
    background-color: #0056d2;
  }
`;

const UserTypesCreate = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEditMode = !!id;
  const handleCancel = () => navigate('/admin/user_types')
  // Fetch data if editing
  useEffect(() => {
    if (isEditMode) {
      restApi(`/api/user-types/${id}`, 'GET')
        .then((res:any) => {
          form.setFieldsValue(res?.data);
        })
        .catch((err) => {
          console.error(err);
          message.error('Failed to fetch Designation');
        });
    }
  }, [id, isEditMode, form]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      setLoading(true)
      const method = isEditMode ? 'PUT' : 'POST';
      const url = isEditMode ? `/api/user-types/${id}` : '/api/user-types';
      await restApi(url, method, values);
      message.success(`Designation ${isEditMode ? 'updated' : 'created'} successfully!`);
      form.resetFields();
      navigate('/admin/user_types'); // redirect to list page
      setLoading(false)
    } catch (error:any) {
      let e = error?.response?.data?.message || "Something went wrong"
      console.error(e);
      setLoading(false)
      message.error(e);
    } finally {
      setLoading(false); // ✅ Always stop the loader
    }
  };

  return (
    <PersistentDrawerLeft>
      <StyledContainer>
        <StyledCard>
          <Title level={3} style={{ textAlign: 'center', marginBottom: 30 }}>
            {isEditMode ? 'Update' : 'Create'} Designation
          </Title>

          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="Type Name"
              name="type_name"
              rules={[{ required: true, message: 'Please enter type name' }]}
            >
              <Input size="middle" placeholder="Enter type name" />
            </Form.Item>

            <Form.Item
              label="Total Number of Days"
              name="total_number_of_days"
              rules={[{ required: true, message: 'Please enter total number of days' }]}
            >
              <InputNumber size="middle" min={1} style={{ width: '100%' }} placeholder="Enter total number of days" />
            </Form.Item>

            <Form.Item
              label="Reminder Days"
              name="no_of_days_reminders"
              rules={[{ required: true, message: 'Please enter reminder days' }]}
            >
              <InputNumber size="middle" min={1} style={{ width: '100%' }} placeholder="Enter reminder days" />
            </Form.Item>

            <Form.Item
              label="Per Month Salary"
              name="perMonthSalary"
              rules={[{ required: true, message: 'Please enter Per Month Salary' }]}
            >
                  <Input size="middle" type="number" style={{ width: '100%' }} placeholder="Enter Per Month Salary" />
            </Form.Item>

            <Form.Item>
              <Space>
                <StyledButton type="primary" htmlType="submit" loading={loading} disabled={loading}>
                  {/* {isEditMode ? 'Update' : 'Create'} Designation */}
                  {loading ? (isEditMode ? 'Updating...' : 'Creating...') : `${isEditMode ? 'Update' : 'Create'} Designation`}
                </StyledButton>
                <Button onClick={handleCancel}>Cancel</Button>
              </Space>
            </Form.Item>
          </Form>
        </StyledCard>
      </StyledContainer>
    </PersistentDrawerLeft>
  );
};

export default UserTypesCreate;
